<template>
  <footer class="bg-[#140A0C] py-8 lg:py-12 border-t border-white/5">
    <div class="container-custom">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-32 mb-8">
        <!-- Left side: Company Info -->
        <div class="md:col-span-2 flex items-center space-x-16">
          <!-- Footer Logo -->
          <div class="shrink-0 hidden md:block">
            <img src="../assets/images/logo.png" alt="Footer Logo" class="h-20 object-contain">
          </div>
          <div class="space-y-6">
            <h3 class="text-white text-xl font-medium">{{ $t('common.companyName') }}</h3>
            <div class="space-y-4 text-slate-400 text-base leading-relaxed">
              <p>{{ $t('common.footer.description1') }}</p>
              <p>{{ $t('common.footer.description2') }}</p>
            </div>
          </div>
        </div>
        
        <!-- Right side: Contact Information -->
        <div class="md:col-span-1 md:flex md:flex-col md:items-end">
          <div class="w-fit space-y-4">
            <h3 class="text-white text-base font-medium">{{ $t('common.footer.contactTitle') }}</h3>
            <div class="space-y-3 text-slate-400 text-sm leading-relaxed">
              <p class="flex">
                <span class="shrink-0 mr-3 text-slate-500">{{ $t('common.footer.addressLabel') }}</span>
                <span>{{ $t('common.footer.addressValue') }}</span>
              </p>
              <p class="flex">
                <span class="shrink-0 mr-3 text-slate-500">{{ $t('common.footer.hotlineLabel') }}</span>
                <span>0519-88552128 88553128</span>
              </p>
              <p class="flex">
                <span class="shrink-0 mr-3 text-slate-500">{{ $t('common.footer.emailLabel') }}</span>
                <span>xhd@czxinghongda.com</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Bottom bar -->
      <div class="pt-6 border-t border-white/5 text-center space-y-2">
        <p class="text-[#4B5563] text-[14px] font-light tracking-widest">
          {{ $t('common.footer.copyright') }}
        </p>
        <p class="text-[#4B5563] text-[14px] font-light tracking-widest">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="hover:text-slate-300 transition-colors duration-200">苏ICP备2026053537号</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
